import { Api } from './axios-config';

export interface ICommissionGoalView {
  id: number;
  name: string;
  periodDays: number;
  metric: string;
  targetScope: string;
  targetProductId?: number;
  targetProductName?: string;
  targetServiceId?: number;
  targetServiceName?: string;
  isActive: boolean;
  tiers: ICommissionGoalTierView[];
}

export interface ICommissionGoalTierView {
  id: number;
  minValue: number;
  maxValue?: number;
  rewardType: string;
  commissionPercent?: number;
  fixedBonus?: number;
}

export interface ICreateCommissionGoal {
  businessId: number;
  name: string;
  periodDays: number;
  metric: number;
  targetScope: number;
  targetProductId?: number;
  targetServiceId?: number;
  isActive?: boolean;
  tiers: ICreateCommissionGoalTier[];
}

export interface ICreateCommissionGoalTier {
  minValue: number;
  maxValue?: number;
  rewardType: number;
  commissionPercent?: number;
  fixedBonus?: number;
}

export interface IUpdateCommissionGoal {
  id: number;
  name: string;
  periodDays: number;
  metric: number;
  targetScope: number;
  targetProductId?: number;
  targetServiceId?: number;
  isActive?: boolean;
  tiers: IUpdateCommissionGoalTier[];
}

export interface IUpdateCommissionGoalTier {
  id?: number;
  minValue: number;
  maxValue?: number;
  rewardType: number;
  commissionPercent?: number;
  fixedBonus?: number;
}

export interface ICommissionGoalUpdateResult {
  id: number;
  forked: boolean;
  message: string;
}

// ── Commission Goal CRUD ──

const getCommissionGoals = async (businessId: number, onlyActive?: boolean): Promise<ICommissionGoalView[]> => {
  const { data } = await Api.get(`/commissionGoal?businessId=${businessId}${onlyActive !== undefined ? `&onlyActive=${onlyActive}` : ''}`);
  return data;
};

const createCommissionGoal = async (body: ICreateCommissionGoal): Promise<number> => {
  const { data } = await Api.post('/commissionGoal', body);
  return data;
};

const updateCommissionGoal = async (body: IUpdateCommissionGoal): Promise<ICommissionGoalUpdateResult> => {
  const { data } = await Api.put('/commissionGoal', body);
  return data;
};

// ── BusinessEmployee Goals ──

const getEmployeeGoals = async (businessEmployeeId: number): Promise<ICommissionGoalView[]> => {
  const { data } = await Api.get(`/commissionGoal/business-employee/${businessEmployeeId}/goals`);
  return data;
};

const setEmployeeGoals = async (businessEmployeeId: number, goalIds: number[]): Promise<void> => {
  await Api.post(`/commissionGoal/business-employee/${businessEmployeeId}/goals`, goalIds);
};

// ── Goal Employees ──

interface IGoalEmployee {
  id: number;
  name: string;
}

const getGoalEmployees = async (goalId: number): Promise<IGoalEmployee[]> => {
  const { data } = await Api.get(`/commissionGoal/${goalId}/employees`);
  return data;
};

const setGoalEmployees = async (goalId: number, businessEmployeeIds: number[]): Promise<void> => {
  await Api.post(`/commissionGoal/${goalId}/employees`, businessEmployeeIds);
};

export const commissionGoalService = {
  getCommissionGoals,
  createCommissionGoal,
  updateCommissionGoal,
  getEmployeeGoals,
  setEmployeeGoals,
  getGoalEmployees,
  setGoalEmployees,
};
